import type { MutationHookOptions } from '@apollo/client'
import {
  BulkCreateSpacecontrolBookingDocument,
  BulkCreateSpacecontrolBookingMutation,
  BulkCreateSpacecontrolBookingMutationVariables,
  GetWorkSpaceSlotsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  BulkCreateSpacecontrolBookingMutation,
  BulkCreateSpacecontrolBookingMutationVariables
>

export const useBulkCreatelBooking = (options?: Options) => {
  const [BulkCreateSpacecontrolBookingMutation, { loading }] = useMutation(
    BulkCreateSpacecontrolBookingDocument,
    {
      ...options,
      awaitRefetchQueries: true,
      extractorFn: (data: BulkCreateSpacecontrolBookingMutation) =>
        data.spaceControlMutations.bulkCreateSpacecontrolBooking,
    }
  )

  return {
    loading,
    bulkCreateSpacecontrolBooking(variables: BulkCreateSpacecontrolBookingMutationVariables) {
      return BulkCreateSpacecontrolBookingMutation({
        variables,
        refetchQueries: [
          {
            query: GetWorkSpaceSlotsDocument,
            variables: { date: variables.date, workSpaceId: variables.workSpaceId },
          },
        ],
      })
    },
  }
}
